import caFlag from './flags/ca.svg';
import deFlag from './flags/de.svg';
import enFlag from './flags/en.svg';
import esFlag from './flags/es.svg';
import euFlag from './flags/eu.svg';
import frFlag from './flags/fr.svg';
import glFlag from './flags/gl.svg';
import itFlag from './flags/it.svg';
import nlFlag from './flags/nl.svg';
import ptFlag from './flags/pt.svg';

/** Flag SVG URLs keyed by ISO 639-1 locale codes */
export const flagUrls: Record<string, string> = {
	ca: caFlag,
	de: deFlag,
	en: enFlag,
	es: esFlag,
	eu: euFlag,
	fr: frFlag,
	gl: glFlag,
	it: itFlag,
	nl: nlFlag,
	pt: ptFlag,
};

/** Maps ISO 3166-1 alpha-2 country codes to ISO 639-1 locale codes for flag lookup */
export const countryCodeToLocale: Record<string, string> = {
	AD: 'ca',
	AT: 'de',
	DE: 'de',
	ES: 'es',
	FR: 'fr',
	GB: 'en',
	IT: 'it',
	NL: 'nl',
	PT: 'pt',
	US: 'en',
};

export function Flag({ locale, className, ...props }: { locale: string } & React.ImgHTMLAttributes<HTMLImageElement>) {
	const src = flagUrls[locale];
	if (!src) return null;
	return <img src={src} alt="" width={20} height={20} className={className} {...props} />;
}
